import { FC } from "react";
import { BoxProps, Separator } from "shared/components/Spor";
import { useTheme } from "styled-components";

type VerticalSeparatorProps = BoxProps;

export const VerticalSeparator: FC<VerticalSeparatorProps> = (props) => {
  const theme = useTheme();
  return (
    <Separator
      alignSelf="center"
      height="36px"
      orientation="vertical"
      borderWidth="1px"
      marginX="3px"
      boxSizing="border-box"
      borderColor={theme.colorOutlineMain}
      {...props}
    />
  );
};
